/**
 * Costs here span four orders of magnitude — a title call is fractions of a
 * cent, a month of generation is tens of dollars — so the precision follows the
 * magnitude instead of a fixed two decimals that would render everything as
 * "$0.00".
 */
export function formatCostUsd(value: number | undefined | null): string {
  if (value == null || !Number.isFinite(value) || value <= 0) return '$0.00';
  if (value < 0.01) return `$${value.toFixed(4)}`;
  if (value < 1) return `$${value.toFixed(3)}`;
  return `$${value.toFixed(2)}`;
}
